import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import "../index.css";
import logo from "../assets/images/logo.png";
import Lottie from "lottie-react";
import animationLogin from "../assets/images/animationLogin.json";
import { Toast } from "primereact/toast";
import {
  AccountsAuthenticate,
  AccountsVerify,
  setAccess,
  setRefresh,
  updateTokens,
} from "../services/services";

export default function Login({ changeState }) {
  const toast = useRef(null);
  const history = useHistory();

  const [step, setStep] = useState("phone"); // 'phone' | 'code'
  const [loading, setLoading] = useState(false);

  const [phone, setPhone] = useState("");
  const [code, setCode] = useState();

  const RESEND_SECONDS = 60;
  const [secondsLeft, setSecondsLeft] = useState(0);
  useEffect(() => {
    if (!secondsLeft) return;
    const t = setInterval(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearInterval(t);
  }, [secondsLeft]);

  const canResend = secondsLeft === 0;

  const showError = (msg = "خطایی رخ داد. دوباره تلاش کنید.") =>
    toast.current?.show({
      severity: "error",
      summary: "خطا",
      detail: msg,
      life: 3000,
    });

  const showSuccess = (msg) =>
    toast.current?.show({
      severity: "success",
      summary: "موفق",
      detail: msg,
      life: 2000,
    });

  const normalizedPhone = useMemo(() => phone.replace(/[^\d]/g, ""), [phone]);
  const validatePhone = () => /^09\d{9}$/.test(normalizedPhone);

  // ---- FIXED: استخراج صحیح توکن Verify مطابق نمونه‌ی شما ----
  const extractVerifyToken = (res) => {
    // حالت‌های رایج سمت شما:
    // 1) res.result => رشته (توکن)
    // 2) res.success => true  (ممکن است همراه با result باشد)
    // 3) برخی سرورها payload مستقیم می‌دهند
    if (!res) return "";
    if (typeof res === "string") return res;
    if (typeof res?.result === "string") return res.result;
    if (typeof res?.data === "string") return res.data;
    if (typeof res?.token === "string") return res.token;
    if (typeof res?.result?.token === "string") return res.result.token;
    return "";
  };

  const handleSendCode = async () => {
    if (!validatePhone()) {
      showError("شماره موبایل نامعتبر است.");
      return;
    }
    setLoading(true);
    try {
      // مطابق نمونه شما، کلید بدنه PhoneNumber است (نه phoneNumber)
      const res = await AccountsAuthenticate({ PhoneNumber: normalizedPhone });

      const verifyToken = extractVerifyToken(res);

      if (!verifyToken && !(res?.success || res?.result)) {
        // اگر نه success و نه result‌ای برنگشته، خطا بده
        showError("ارسال کد ناموفق بود.");
        return;
      }

      // اگر success بود ولی توکن توی result بود، باز هم بالا خوانده‌ایم
      if (verifyToken) {
        localStorage.setItem("TOKENVERIFY", verifyToken);
      }

      setStep("code");
      setSecondsLeft(RESEND_SECONDS);
      showSuccess("کد تأیید ارسال شد.");
    } catch (e) {
      showError("ارسال کد ناموفق بود.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async () => {
    if (!code || code.length < 4) {
      showError("کد تأیید نامعتبر است.");
      return;
    }

    setLoading(true);
    try {
      // طبق سرویس فعلی شما body شیء است
      const res = await AccountsVerify(Number(code));
      const payload = res?.result ?? res;

      const accessToken =
        payload?.accessToken ||
        payload?.data?.accessToken ||
        payload?.result?.accessToken;
      const refreshToken =
        payload?.refreshToken ||
        payload?.data?.refreshToken ||
        payload?.result?.refreshToken;

      if (!accessToken || !refreshToken) {
        showError("ورود ناموفق بود. لطفاً دوباره تلاش کنید.");
        return;
      }

      updateTokens(accessToken, refreshToken);
      // سازگاری با کلیدهای قدیمی در پروژه
      localStorage.setItem("tokenApiNew", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      setAccess(accessToken);
      setRefresh(refreshToken);

      showSuccess("ورود با موفقیت انجام شد.");
      changeState?.(true);
      history.push("/");
    } catch (e) {
      showError("کد تأیید اشتباه است یا منقضی شده.");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    if (!canResend) return;
    await handleSendCode();
  };

  return (
    <div style={{ display: "flex", height: "100vh", background: " #181818" }}>
      <Toast ref={toast} />

      <div className="d-flex flex-column justify-content-center align-items-center px-5 flex-grow-1 position-relative">
        <img
          src={logo}
          width={80}
          style={{
            position: "absolute",
            top: "22px",
            right: "2px",
            transform: "translateX(-50%)",
          }}
          alt="logo"
        />

        <h4 style={{ color: "#fff" }}>ورود</h4>

        {step === "phone" && (
          <>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: 50,
              }}
            >
              <input
                type="tel"
                dir="ltr"
                placeholder="09xxxxxxxxx"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="input-login"
              />
            </div>

            <div className="mt-4">
              <button
                style={{
                  color: "#fff",
                  background: "#68b9da",
                  border: 0,
                  width: 140,
                  height: 39,
                  borderRadius: 8,
                  padding: 2,
                }}
                onClick={handleSendCode}
                disabled={loading}
              >
                {loading ? "در حال ارسال..." : "ارسال کد تایید"}
              </button>
            </div>
          </>
        )}

        {step === "code" && (
          <>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: 36,
              }}
            >
              <input
                id="otp"
                type="text"
                dir="ltr"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="کد ۴ تا ۶ رقمی"
                value={code}
                onChange={(e) => setCode(e.target.value.replace(/[^\d]/g, ""))}
                className="input-login"
                style={{ letterSpacing: 4, textAlign: "center" }}
              />
            </div>

            <div
              className="mt-2"
              style={{ display: "flex", gap: 12, alignItems: "center" }}
            >
              <button
                style={{
                  color: "#fff",
                  background: "#85cae5",
                  border: 0,
                  width: 108,
                  height: 39,
                  borderRadius: 8,
                  padding: 2,
                }}
                onClick={handleVerify}
                disabled={loading}
              >
                {loading ? "در حال ورود..." : "تایید"}
              </button>

              <button
                style={{
                  color: "#fff",
                  background: "#585858",
                  width: 120,
                  height: 39,
                  borderRadius: 8,
                  padding: 2,
                }}
                onClick={handleResend}
                disabled={!canResend || loading}
                title={canResend ? "" : `ارسال مجدد در ${secondsLeft}s`}
              >
                {canResend ? "ارسال مجدد" : `تا ${secondsLeft}s`}
              </button>
            </div>

            <div
              className="mt-2"
              style={{ fontSize: 12, color: "#6b7280", userSelect: "none" }}
            >
              کد برای شماره {normalizedPhone} ارسال شد.
            </div>
          </>
        )}
      </div>

      <div
        style={{
          flex: 1.5,
          background: "linear-gradient(to bottom right, #ffff, #7dc7e4)",
          clipPath: "ellipse(100% 150% at 0% 30%)",
          display: "grid",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          ...(window.innerWidth < 576 ? { flex: 0 } : {}),
        }}
      >
        <div className="d-none d-sm-block">
          <Lottie
            animationData={animationLogin}
            loop={true}
            style={{ width: 600, height: 600, position: "relative", zIndex: 2 }}
          />
        </div>
      </div>
    </div>
  );
}
